import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AuthLayout from "../../components/auth/AuthLayout";

export default function SignupSuccess() {
  const location = useLocation();
  const navigate = useNavigate();
  const { email, needsConfirmation } = location.state || { email: '', needsConfirmation: true };

  // Redirect to home if accessed directly without state
  if (!email) {
    navigate('/');
    return null;
  }

  return (
    <AuthLayout
      title="Account Created Successfully!"
      metaTitle="Sign Up Success | PDF ConvertOne"
      metaDescription="Your account has been created successfully"
    >
      <div className="text-center">
        {/* Success Icon */}
        <div className="flex justify-center mb-6">
          <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-green-100 dark:bg-green-900/20">
            <svg 
              width="32" 
              height="32" 
              viewBox="0 0 24 24" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
              className="text-green-600 dark:text-green-400"
            >
              <path 
                d="M20 6L9 17L4 12" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
        
        {needsConfirmation ? (
          <div>
            <p className="mb-6 text-gray-600 dark:text-gray-400">
              We've sent a confirmation email to <strong>{email}</strong>. Please check your email and follow the instructions to confirm your account.
            </p>
            <p className="mb-8 text-sm text-gray-500 dark:text-gray-500">
              If you don't see the email, please check your spam folder.
            </p>
          </div>
        ) : (
          <p className="mb-6 text-gray-600 dark:text-gray-400">
            Your account has been created successfully. You can now use all the features of PDF ConvertOne.
          </p>
        )}

        <div className="flex flex-col sm:flex-row justify-center gap-3">
          <Link
            to="/signin"
            className="px-6 py-3 text-sm font-medium text-white bg-brand-500 rounded-lg hover:bg-brand-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500 text-center"
          >
            Sign In
          </Link>
          <Link
            to="/"
            className="px-6 py-3 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700 text-center"
          >
            Go to Home
          </Link>
        </div>
      </div>
    </AuthLayout>
  );
} 